<template>
	<section class="marketing-section bg-color-bg-tertiary">
		<div class="container">
			<div class="grid display-flex-smo flex-direction-column-smo">
				<div class="col-6-md col-12-smo pr-250-md text-align-center-smo">
					<h2 class="overline">Why private credit</h2>
					<h3 class="heading-1 mt-150">A once-in-a-decade lending environment</h3>
					<div class="body-md text-color-content-secondary mt-100">
						<p>
							The Federal Reserve raised interest rates at record-breaking speeds in 2023 in an attempt to
							tame inflation. This policy shift has destabilized markets, leading to broad dislocations,
							increased strain across the system, and a potential liquidity crisis that presents a risk to
							the global economy.
						</p>
						<p class="mt-150">
							Simultaneously, those factors have combined to create what we believe is arguably the most
							attractive environment for credit investments in a generation.
						</p>
					</div>
				</div>
				<div class="col-6-md col-12-smo mt-300-smo">
					<div>
						<img :src="chartImgSrc" :alt="chartImgAlt" />
						<p class="body-xs text-color-content-tertiary"
							><strong>Source: </strong> {{ imageSourceDescription }}</p
						>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { computed } from 'vue';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();

const chartImgAlt = 'Inverted Yield Curve Chart';

const imageSourceDescription =
	'Historical Treasury rates sourced from St. Louis Federal Reserve Economic Data (FRED). Forecast based on FOMC projections for the Fed Funds rate and Fundrise internal analysis of Treasury spread behavior from historical yield curve inversion events.';

const chartImgSrc = computed((): string => {
	return `${appCloudfrontPath}/images/marketing-site/inverted-yield-curve-${
		appStore.isMobile ? 'mobile' : 'desktop'
	}.png`;
});
</script>
